<template>
  <div class="goods-list">
    <div v-for="item in list" :key="item.id" :class="{ 'is-selected': item.selected, item }" @click="clickItem(item)">
      <div class="image">
        <a-tooltip placement="right" overlayClassName="image-popover">
          <template #title>
            <img :src="item.img" width="450" height="450" />
          </template>
          <img :src="item.img" @click.stop="openPage(item.link)" />
        </a-tooltip>
      </div>
      <div
        :class="{
          'goods-info': true,
          'is-taote': isTaoteKeyword,
          'is-ali': isAliKeyword,
          'is-taoteKeyword2': isTaoteKeyword2 || item.tradeName,
          'is-taote-activity': item.activityPrice && item.activityQuality,
          'is-search-image': isSearchImage,
        }"
      >
        <p class="goods-name">
          <a-tooltip placement="top" overlayClassName="goods-name-popover">
            <template #title>
              {{ item.name }}
            </template>
            <span class="hide-str-2" @click.stop="openPage(item.link)">
              {{ item.name }}
            </span>
          </a-tooltip>
        </p>
        <div v-show="item.price || item.priceStr || item.activityPrice" class="price-box">
          <span class="price-item">
            <span v-show="item.activityPrice && item.activityQuality" class="flag">
              限时，库存: {{ item.activityQuality }}
            </span>
            ￥{{ item.activityPrice || item.price || item.priceStr }}
            <span v-if="item.oldPrice && item.price !== item.oldPrice" class="old-price-item">
              {{ item.oldPrice }}
            </span>
            <span v-show="!isTaoteKeyword2 && item.highSkuPrice && item.highSkuPrice !== item.price"
              >- {{ item.highSkuPrice }}</span
            >
          </span>
          <span v-show="item.sold !== '0' && item.sold" style="font-size: 13px; line-height: 1">
            {{ isNaN(item.sold) ? item.sold : "月销量: " + item.sold }}
          </span>
        </div>
        <div v-show="item.activityPrice && item.activityQuality && item.activityEndTime" class="end-time">
          截止: {{ item.activityEndTime }}
        </div>
        <div v-show="item.gmvValue" style="padding-left: 0">成交额: {{ item.gmvValue }}</div>
        <div v-show="item.tradeName" style="padding-left: 0; margin: 0.3em 0">
          <a-tag color="red" style="font-size: 14px; flex: inherit; width: auto; text-align: left">
            {{ item.tradeName }}
          </a-tag>
        </div>
        <div v-show="item.category">
          <span> 类<i style="margin-left: 2em" />目： </span>
          <a-tooltip placement="top" overlayClassName="goods-name-popover">
            <template #title>
              {{ item.category }}
            </template>
            <span class="hide-str-2" style="color: black">
              {{ item.category }}
            </span>
          </a-tooltip>
        </div>
        <div v-show="item.hot">
          <span> 热<i style="margin-left: 2em" />度： </span>
          <span style="color: red">{{ item.hot }}</span>
        </div>
        <div v-show="item.brandName">
          <span> 品<i style="margin-left: 2em" />牌： </span>
          <a-tooltip placement="top" overlayClassName="goods-name-popover">
            <template #title>
              {{ item.brandName }}
            </template>
            <span class="hide-str-2" style="color: black">
              {{ item.brandName }}
            </span>
          </a-tooltip>
        </div>
        <div v-show="item.searchCount" class="search-value">
          <span> 7天搜索量 {{ item.searchCount }} </span>
        </div>
        <div v-if="item.serviceList?.length" class="service-list-tags">
          <a-tag v-for="option in item.serviceList" :key="option.name" color="red">{{ option.name }}</a-tag>
        </div>
        <template v-if="isTaoteKeyword">
          <div>
            <span>好<i style="margin-left: 0.5em" />评<i style="margin-left: 0.5em" />率：</span>
            <a-tag :color="item.haopinlvColor" class="lv-tag">{{ item.haopinlv }}</a-tag>
          </div>
          <div>
            <span>退<i style="margin-left: 0.5em" />货<i style="margin-left: 0.5em" />率：</span>
            <a-tag :color="item.tuihuolvColor" class="lv-tag">{{ item.tuihuolv }}</a-tag>
          </div>
          <div v-if="item.kefuxiangying != '未知'">
            <span>客服响应：</span>
            <a-tag :color="item.kefuxiangyingColor" class="lv-tag">{{ item.kefuxiangying }}</a-tag>
          </div>
          <div v-if="item.fahuoTime != '未知'">
            <span>发货时效：</span>
            <a-tag :color="item.fahuoTimeColor" class="lv-tag">{{ item.fahuoTime }}</a-tag>
          </div>
        </template>
        <div class="btns">
          <a-button v-show="!noCopyLink" type="primary" @click.stop="copyToClipboard(item.link)">复制链接</a-button>
          <a-button type="primary" @click.stop="addPreview(item)" danger :disabled="item.isMoved && !canCommitRepeat"
            >铺货预览</a-button
          >
          <div class="checkbox-box" :style="{ bottom: '34px' }">
            <a-tag v-if="item.shipIn24" color="blue">24小时发货</a-tag>
            <a-tag v-if="item.isMoved" color="red">已铺货</a-tag>
            <a-checkbox
              v-show="!noSelect"
              v-model:checked="item.selected"
              :disabled="item.isMoved && !canCommitRepeat"
            />
          </div>
          <slot name="btn" :item="item" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { COU_CopyToClipboard } from "@/utils/co_util";
export default {
  props: {
    list: Array,
    noSelect: Boolean,
    noCopyLink: Boolean,
    isTaoteKeyword: Boolean,
    isTaoteKeyword2: Boolean,
    isAliKeyword: Boolean,
    canCommitRepeat: Boolean,
    isSearchImage: Boolean,
  },
  emits: ["add-preview", "click-item"],
  methods: {
    // 打开新页面
    openPage(url) {
      url && window.open(url);
    },
    // 点击item时
    clickItem(item) {
      if (!item.isMoved || this.canCommitRepeat) {
        item.selected = !item.selected;
        this.$emit("click-item", item);
      }
    },
    // 复制文本
    copyToClipboard(str) {
      COU_CopyToClipboard(str);
      this.$message.success("复制商品链接成功");
    },
    // 点击【铺货预览】时
    addPreview(item) {
      item.selected = false;
      this.$emit("add-preview", [item]);
    },
  },
};
</script>
<style>
.image-popover {
  max-width: inherit;
}
.goods-name-popover {
  max-width: 350px;
}
</style>
<style scoped lang="less">
@import "./index";
</style>
